import type { LDClient } from 'launchdarkly-react-client-sdk';

import type { LDFlagSetRaw } from './flags';
import { waitForLDClient } from './ld-provider';

export abstract class LDAdapter {
  client: LDClient | undefined;

  abstract ready(): Promise<void>;

  abstract allFlags(): Promise<LDFlagSetRaw | null>;
}

export class MockLaunchDarklyAdapter implements LDAdapter {
  client: LDClient | undefined;

  ready = async (): Promise<void> => {
    await Promise.resolve();
  };

  allFlags = async (): Promise<LDFlagSetRaw | null> => {
    await this.ready();
    return null;
  };
}

export class LaunchDarklyAdapter implements LDAdapter {
  client: LDClient | undefined = undefined;

  ready = async (): Promise<void> => {
    if (!this.client) {
      this.client = await waitForLDClient();
    }
  };

  allFlags = async (): Promise<LDFlagSetRaw | null> => {
    await this.ready();

    if (!this.client) {
      return null;
    }

    return this.client.allFlags();
  };
}
